module.exports = __webpack_public_path__ + "images/f4aae99e2ba818aff0f9a72932e80552-illu_freezeSensor.svg";